var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"inline-block mr-2 whitespace-nowrap",attrs:{"to":_vm.link}},[_c('neo-realm-indicator',{attrs:{"realm":_vm.realm}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }